/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuntimeStatus
 */
export interface RuntimeStatus {
    /**
     * The number of compute nodes that are registered and can run the runtime.
     * @type {number}
     * @memberof RuntimeStatus
     */
    active_nodes: number;
    /**
     * The height of the most recent indexed block (also sometimes referred to as "round") for this runtime. Query a synced Oasis node for the latest block produced.
     * @type {number}
     * @memberof RuntimeStatus
     */
    latest_block: number;
    /**
     * The RFC 3339 formatted consensus time of when the latest indexed block for this runtime was produced.
     * @type {Date}
     * @memberof RuntimeStatus
     */
    latest_block_time: Date;
    /**
     * The number of milliseconds since Nexus processed the latest block.
     * @type {number}
     * @memberof RuntimeStatus
     */
    latest_update_age_ms: number;
}

export function RuntimeStatusFromJSON(json: any): RuntimeStatus {
    return RuntimeStatusFromJSONTyped(json, false);
}

export function RuntimeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active_nodes': json['active_nodes'],
        'latest_block': json['latest_block'],
        'latest_block_time': (new Date(json['latest_block_time'])),
        'latest_update_age_ms': json['latest_update_age_ms'],
    };
}

export function RuntimeStatusToJSON(value?: RuntimeStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active_nodes': value.active_nodes,
        'latest_block': value.latest_block,
        'latest_block_time': (value.latest_block_time.toISOString()),
        'latest_update_age_ms': value.latest_update_age_ms,
    };
}


